import { FileTextOutlined } from "@ant-design/icons"
import { type MenuItemType } from "components/Menu/Menu"
import { Modal } from "components/Modal/Modal"
import { useDisclosure } from "hooks/useDisclosure"
import { useCallback, useState } from "react"
import { useLegalURLs, useUserRole } from "services/users"

export function useViewLegal() {
	const { data: { isPatient, isProvider } = {} } = useUserRole()
	const legalEnabled = isPatient || isProvider
	const { data: { termsOfUse, privacyPolicy } = {} } =
		useLegalURLs(legalEnabled)
	const [state, setState] = useState<State>()
	const disclosure = useDisclosure()
	const onClick = useCallback(
		(newState: State) => {
			setState(newState)
			disclosure.open()
		},
		[disclosure],
	)

	return {
		items: [
			...(legalEnabled
				? [
						{
							key: "terms-of-use",
							label: "Terms of use",
							icon: <FileTextOutlined aria-hidden />,
							onClick: () =>
								termsOfUse &&
								onClick({ legalUrl: termsOfUse, title: "Terms of use" }),
						} as MenuItemType,
						{
							key: "privacy-policy",
							label: "Privacy policy",
							icon: <FileTextOutlined aria-hidden />,
							onClick: () =>
								privacyPolicy &&
								onClick({ legalUrl: privacyPolicy, title: "Privacy policy" }),
						},
					]
				: []),
		],
		viewer:
			disclosure.isOpen && state ? (
				<Modal
					open
					title={state.title}
					okText="OK"
					onOk={disclosure.close}
					onCancel={disclosure.close}
					cancelButtonProps={{ className: "hidden" }}
					className="min-w-dvw"
					classNames={{
						mask: "fixed",
						wrapper: "fixed p-0",
						container: "max-h-dvh min-h-dvh rounded-none",
						body: "h-svh",
					}}
				>
					{state.legalUrl && (
						<iframe
							key={state.legalUrl}
							allow="fullscreen"
							title="Legal document"
							className="size-full w-full flex-1 border-0"
							src={state.legalUrl}
						/>
					)}
				</Modal>
			) : null,
	}
}

interface State {
	legalUrl: string
	title: string
}
